export const getBestMatchingPlayer = (playerFullName: string | undefined, substitute: string | null | undefined) => {
    if (substitute && substitute !== 'null') {
        return substitute;
    }
    return playerFullName || '- -';
}